import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import UserStore from '../../util/UserStore';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import $ from 'jquery';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import HawkEye from '../../util/HawkEye';
import CoreAjax from '../../util/CoreAjax';
import heymathlogo from '../../images/heymathlogo.png';

export default class VendorLogin extends PreLoginPage{
	
	constructor(props) {
		super(props);
		this.UserStore = new UserStore();
		this.navigationKey="PLP_Navigation";
		this.navigateURLKey="PLP_REDIRECT";
		this.navigateObj = {};
		
		this.doLumosLogout = this.doLumosLogout.bind(this);
	}

	updateUserType(commonCallback){
		var me=this;
		var callBackSuccess = function(response){
			if(response!== null){
				//console.warn("user type",response)
				me.UserStore.set(response);
			}

			if(typeof commonCallback === "function"){
				commonCallback.apply(this);
			}
		}

		var callBackFailure = function(response){
			//console.warn("failure ",response);
			if(typeof commonCallback === "function"){
				commonCallback.apply(this);
			}
		}
		
		super.updateUserType(callBackSuccess,callBackFailure)
	}
	
	
	componentDidMount() {
		var me = this;
		var params = this.getAllParamsObj();
		console.log("query params:::",params);
		
		if(Object.keys(params).length <= 0){
			this.showErrorMsg();
			return;
		}
		
		var success = function(response){
			console.log("External login ajax success... ");
			console.log("authResponse ::",userObj);
			var userObj = response.user;
			if(typeof userObj === "object" && userObj.authToken){
				//Update the userStore Object
				me.UserStore.set(userObj);
				
				try{
					me.doLumosLogout();
				}catch(e){}
					
					
				try {
					me.navigateObj = JSON.parse(BrowserStorageUtil.getStoredSessionItem(me.navigationKey));
										
					try{
						var loginObj = {
								"user_id" : (userObj == null) ? "" : userObj.userId,
								"login_id" : (userObj == null) ? "" : userObj.loginId,
								"user_agent" : navigator.userAgent,
								"platform" : navigator.platform,
								"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
								"ip_address" : "ip_address",
								"result" : true,
								"session_id" : (userObj == null) ? "" : userObj.authToken
						}
						
						me.storeTrackEvent("login", loginObj);
					}catch(e){}
					
					//me.props.history.push("/");
					
					let afterUpdate = function(){
						me.hmNav(userObj);
					};
					me.updateUserType(afterUpdate);
					
					
				} catch (e) {}
		
				
			}else{
				//Clear userStore
				me.UserStore.clearOldUser();
				me.showErrorMsg(response.message);
			}
		}

		var failure = function(error){
			//User session is no longer valid
			console.log("External login ajax failure...",error);
			me.showErrorMsg();
		}
		
		//this.sessionCheck(success,failure);
		new CoreAjax(me.getUrlFor("UOLO_LOGIN")+"?data="+params.data).get(success,failure);
	}


	hmNav = (userobj) => {
		console.log("hmnav userobj:::",userobj);
		var me = this;
		
		if(this.productsAvailableToAccess(userobj)){
			window.top.location.href = "/landing";
		}else{
			if(userobj && userobj.userRole && userobj.userRole.role && userobj.userRole.role.toUpperCase() === "TCHR"){
				window.top.location.href = "/teachers";
			}else{
				window.top.location.href = '/products';
			}			
		}
		
	}
	productsAvailableToAccess(userobj){
		var user = userobj;
		//console.log("user::::",user);
		if(user != null){
			var permissions = user.entlHistory;//console.log("permissions:::",permissions);
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}
	showErrorMsg(errRef=""){
		var me = this;
		var msg = me.rb("profile.oops");
		if(errRef != ""){
			msg = me.rb("uolo.forbidden.msg") + (errRef.toLowerCase().split("error ::")[1] || errRef);
		}
		
        var buttons = [{
            label: me.rb("alert.ok"),
            handler: () => { me.props.history.push("/"); }
        }]        
        me.showAlert(" ", msg, buttons);
	}
	getAllParamsObj(){
		var paramObj = {};
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				paramObj = this.extractParamsObj(paramsArr[1]);			   
			}
		}catch(e){}

		return paramObj;
	}
	extractParamsObj(paramsArrStr){
		var paramObj = {};
		try{
			if(paramsArrStr !== null && paramsArrStr.length > 0){
				var paramPairArr = paramsArrStr.split("&");
				if(paramPairArr !== null && paramPairArr.length > 0){
					for(var i=0; i < paramPairArr.length; i++){
						var eachPair = paramPairArr[i].split("=");
						paramObj[eachPair[0]] = (eachPair.length > 0) ? eachPair[1] : eachPair[0];
					}
				}
			}
		}catch(e){}

		return paramObj;
	}
	trackMe(result,userObj=null){
		var trackObj = {
				"user_id" : (userObj == null) ? "" : userObj.userId,
				"login_id" : (userObj == null) ? "" : userObj.loginId,
				"user_agent" : navigator.userAgent,
				"platform" : navigator.platform,
				"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
				"ip_address" : "ip_address",
				"result" : (result === true),
				"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	initiateTrack(trackKey, addnldata){
		try{
			var eventObj = this.getTracker();
			
			var trackObj = eventObj.getEventObject(eventObj.eventCodes[trackKey]);
	
			trackObj.event_details.user_id = addnldata.user_id || "";
			trackObj.event_details.session_id = addnldata.authToken || "";
			trackObj.event_details.timestamp = new Date().getTime() || "";			
			
			if(addnldata !== undefined && typeof addnldata === "object"){
				for(var key in addnldata){
					trackObj.event_data[key] = addnldata[key];
				}
			}
			
			var output = {"event":trackObj};
			var me = this;      		
			new HawkEye(output).post();
		}catch(e){
			console.log("Error in Tracking :::",e);
		}
	}
	doLumosLogout(){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
	            url: me.getUrlFor("LUMOS_LOGOUT"),	            
	            type: 'GET',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			
	    		},
	            error: function(response){
	    			console.log("Error in LUMOS_LOGOUT",response);
	    		}
	    });
	}

	render() {	
		
			return (  
					<div> 
						<div className="centerhlogo">
							<img src={heymathlogo} />
						</div>
							
						{this.showLoader()}
					</div>
			);
	}
}


// WEBPACK FOOTER //
// ./src/views/extlogin/VendorLogin.js